// Text match weighting shared by description suggestions (server) and project ranking (client)
// (architecture sprint-03 §3.4). Dependency-free, like every module in src/shared.

const WEIGHT_EXACT = 1;
const WEIGHT_PREFIX = 0.9;
const WEIGHT_WORD_START = 0.7;
const WEIGHT_SUBSTRING = 0.4;
const WEIGHT_NONE = 0;
const WORD_CHAR = /[\p{L}\p{N}]/u;

/** Lower-case, trim, collapse internal whitespace to one space. */
export function normaliseForMatch(s: string): string {
  return s.trim().replace(/\s+/g, ' ').toLowerCase();
}

function startsAWord(text: string, query: string): boolean {
  let index = text.indexOf(query, 1);
  while (index > 0) {
    const before = text[index - 1] ?? '';
    if (!WORD_CHAR.test(before)) return true;
    index = text.indexOf(query, index + 1);
  }
  return false;
}

/**
 * Match quality of `query` against `text` (both normalised here):
 * '' or exact 1.0; prefix 0.9; start of a later word 0.7; substring 0.4; otherwise 0.
 */
export function matchWeight(text: string, query: string): number {
  const t = normaliseForMatch(text);
  const q = normaliseForMatch(query);
  if (q === '' || t === q) return WEIGHT_EXACT;
  if (t.startsWith(q)) return WEIGHT_PREFIX;
  if (startsAWord(t, q)) return WEIGHT_WORD_START;
  if (t.includes(q)) return WEIGHT_SUBSTRING;
  return WEIGHT_NONE;
}
